import React from "react";
import Constants from "../constants/Constants";

const CommentItem = ({ comment, modelAv }) => {
  return (
    <>
      <div className="row">
        <div className="avatar">
          <img
            src={
              comment.avatar === "def"
                ? `${Constants.AVATAR_URL}${comment.avatar}-sm.jpg`
                : `${Constants.AVATAR_URL}${comment.avatar}.jpg`
            }
            alt="Member Avatar"
          />
        </div>
        <div className="content">{comment.comment}</div>
      </div>
      {comment.models_comment ? (
        <div className="row reply">
          <div className="avatar">
            <img
              src={`${Constants.CDN}/images/${modelAv}.jpg`}
              alt="Member Avatar"
            />
          </div>
          <div className="content">{comment.models_comment}</div>
        </div>
      ) : null}
    </>
  );
};

export default CommentItem;
